const CHART_SERIES = [
    {
        name: 'Management',
        value: 12.56,
        colorValue: 12,
    },
    {
        name: 'Case manager',
        value: 6.75,
        colorValue: 6,
    },
    {
        name: 'Nociceptive Pain',
        value: 16.43,
        colorValue: 16,
    },
    {
        name: 'Crap Gap',
        value: 9.07,
        colorValue: 9,
    },
    {
        name: 'Regimen',
        value: 5.67,
        colorValue: 5,
    },
    {
        name: 'Radiologically Isolated Syndrome (RIS)',
        value: 11.03,
        colorValue: 11,
    },
    {
        name: 'Clinically Isolated Syndrome (CIS)',
        value: 24.12,
        colorValue: 24,
    },
    {
        name: 'Neoadjuvant therapy',
        value: 12.41,
        colorValue: 12,
    },
    {
        name: 'Imaging test',
        value: 6.0,
        colorValue: 6,
    },
    {
        name: 'Targeted therapy',
        value: 3.66,
        colorValue: 3,
    },
    {
        name: 'Oligoclonal Bands',
        value: 2.04,
        colorValue: 2,
    },
];

export const CHART_OPTIONS_KEYWORD_1 = {
    chart: {
        type: 'treemap',
        height: '100%',
        plotBackgroundColor: null,
        backgroundColor: 'transparent',
        margin: 0,
    },
    title: {
        text: null,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400,
        },
        formatter: function() {
            let value = this.series.valueData[this.x];
            return `<b>${this.key}</b>: ${value}%<br>`;
        },
    },
    colorAxis: {
        minColor: '#FAE8C7',
        // #FBD182
        maxColor: '#FDB022',
    },
    plotOptions: {
        treemap: {
            // layoutAlgorithm: 'sliceAndDice',
            layoutAlgorithm:'squarified',
            alternateStartingDirection: true,
            borderColor: '#fff',
            borderRadius: 6,
            borderWidth: 2,
            dataLabels: {
                style: {
                    textOutline: 'none',
                    fontSize: '12px',
                    fontWeight: 400,
                },
            },
        }
    },
    series: [
        {   
            name: 'Keyword 1',
            data: CHART_SERIES,
        },
    ],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 250 // Work Before Width 1249px for column 4 if maxWidth is 250.
            },
            chartOptions: {
                tooltip: {
                    style: {
                       fontSize: '10px',
                    },
                },
            }
        }]
    }
};

export const CHART_OPTIONS_KEYWORD_2 = {
    chart: {
        type: 'treemap',
        height: '100%',
        plotBackgroundColor: null,
        backgroundColor: 'transparent',
        margin: 0,
    },
    title: {
        text: null,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400,
        },
        formatter: function() {
            let value = this.series.valueData[this.x];
            return `<b>${this.key}</b>: ${value}%<br>`;
        },
    },
    colorAxis: {
        minColor: '#CEC0F7',
        maxColor: '#6938EF',
        // maxColor: '#733567',
    },
    plotOptions: {
        treemap: {
            // layoutAlgorithm: 'sliceAndDice',
            layoutAlgorithm:'squarified',
            alternateStartingDirection: true,
            borderColor: '#fff',
            borderRadius: 6,
            borderWidth: 2,
            dataLabels: {
                style: {
                    textOutline: 'none',
                    fontSize: '12px',
                    fontWeight: 400,
                },
            },
        }
    },
    series: [
        {   
            name: 'Keyword 2',
            data: CHART_SERIES,
        },
    ],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 250 // Work Before Width 1249px for column 4 if maxWidth is 250.
            },
            chartOptions: {
                tooltip: {
                    style: {
                       fontSize: '10px',
                    },
                },
            }
        }]
    }
};

export const CHART_OPTIONS_KEYWORD_3 = {
    chart: {
        type: 'treemap',
        height: '100%',
        plotBackgroundColor: null,
        backgroundColor: 'transparent',
        margin: 0,
    },
    title: {
        text: null,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400,
        },
        formatter: function() {
            let value = this.series.valueData[this.x];
            return `<b>${this.key}</b>: ${value}%<br>`;
        },
    },
    colorAxis: {
        minColor: '#D1E8FC',
        // #9cd1fc
        maxColor: '#53B1FD',
    },
    plotOptions: {
        treemap: {
            // layoutAlgorithm: 'sliceAndDice',
            layoutAlgorithm:'squarified',
            alternateStartingDirection: true,
            borderColor: '#fff',
            borderRadius: 6,
            borderWidth: 2,
            dataLabels: {
                style: {
                    textOutline: 'none',
                    fontSize: '12px',
                    fontWeight: 400,
                },
            },
        }
    },
    series: [
        {   
            name: 'Keyword 3',
            data: CHART_SERIES,
        },
    ],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 250 // Work Before Width 1249px for column 4 if maxWidth is 250.
            },
            chartOptions: {
                tooltip: {
                    style: {
                       fontSize: '10px',
                    },
                },
            }
        }]
    }
};